import TableBody from "@material-ui/core/TableBody";
import Table from "@material-ui/core/Table";
import Typography from "@material-ui/core/Typography";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import ReczeeChart from "./ReczeeChart";
import React from "react";
import PieChartIcon from "@material-ui/icons/PieChart";
import { makeStyles } from "@material-ui/core/styles";
import ViewListIcon from "@material-ui/icons/ViewList";
import { Tabs, Tab } from "@material-ui/core";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import GetAppIcon from "@material-ui/icons/GetApp";
import EditIcon from "@material-ui/icons/Edit";
import ShareIcon from "@material-ui/icons/Share";
import SaveIcon from "@material-ui/icons/Save";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import DeleteIcon from "@material-ui/icons/Delete";
import { useHistory } from "react-router";
import amplitudeLogger from "../../../../utils/amplitude";
import {
  ClickAwayListener,
  Button,
  Grow,
  IconButton,
  MenuItem,
  MenuList,
  Paper,
  Divider,
  Popper,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "95%",
    minHeight: "450px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  redText: {
    color: theme.palette.error.main,
  },
  extraMenuItem: {
    padding: "4px 12px",
  },
  chartTypetab: {
    width: "48px",
    minWidth: "48px",
    padding: "8px",
    paddingTop: "8px",
  },
  actionButton: {
    marginLeft: "12px",
    padding: "4px",
  },
  saveButton: {
    marginRight: "4px",
    marginTop: "6px",
    color: theme.palette.primary.main,
  },
  chartTypeTabsContainer: {
    marginRight: "4px",
    width: "fit-content",
    display: "inline-flex",
  },
  graphContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
  },
  dropdownElements: {
    marginLeft: "6px",
    marginRight: theme.spacing(1),
  },
  graphTitleContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  rightTitleContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  leftTitleContainer: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));

const isVisibleAttribute = (visibleAttributes, prop) => {
  return visibleAttributes && visibleAttributes.indexOf(prop) > -1;
};

function AnalyticsChart({
  title,
  subtitle,
  analyticsObject,
  backendData,
  visibleAttributes,
  shareToken,
  onSave,
  onDelete,
  chartSlug,
  selectedMetric,
  amplitudePage,
}) {
  const classes = useStyles();
  const history = useHistory();
  const [chartType, setChartType] = React.useState(0);
  let tableData =
    analyticsObject && backendData && chartType === 1
      ? analyticsObject.getTableRepresentation(backendData)
      : [];
  const [open, setOpen] = React.useState(false);
  const [graphBase64, setGraphBase64] = React.useState(null);
  const anchorRef = React.useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    }
  }

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  const onLoadCallback = (base64) => {
    setGraphBase64(base64);
  };

  const handleDownload = (event) => {
    if (!graphBase64) return;
    var a = document.createElement("a");
    a.href = graphBase64;
    a.download = `${title}.png`;
    a.click();
  };

  return (
    <div className={classes.root}>
      <div className={classes.graphTitleContainer}>
        <div className={classes.leftTitleContainer}>
          <Typography variant="h6">{title}</Typography>
          {subtitle}
        </div>
        <div className={classes.rightTitleContainer}>
          {isVisibleAttribute(visibleAttributes, "Save") ? (
            <Button
              variant="standard"
              color="primary"
              className={classes.saveButton}
              startIcon={<SaveIcon />}
              onClick={() => {
                amplitudeLogger.logEvent("CLICK_CHART_OPTIONS", {
                  attribute: "save",
                  page: amplitudePage,
                  metric_name: selectedMetric,
                });
                onSave();
              }}
            >
              Save
            </Button>
          ) : (
            ""
          )}
          {isVisibleAttribute(visibleAttributes, "tableView") ? (
            <Tabs
              value={chartType}
              onChange={(_, value) => {
                amplitudeLogger.logEvent("CLICK_CHART_OPTIONS", {
                  attribute: value === 0 ? "chart" : "table",
                  page: amplitudePage,
                  metric_name: selectedMetric,
                });
                setChartType(value);
              }}
              className={classes.chartTypeTabsContainer}
            >
              <Tab
                classes={{ root: classes.chartTypetab }}
                label={<PieChartIcon size="small" />}
              />
              <Tab
                classes={{ root: classes.chartTypetab }}
                label={<ViewListIcon size="small" />}
              />
            </Tabs>
          ) : (
            ""
          )}

          {isVisibleAttribute(visibleAttributes, "kebabMenu") ? (
            <IconButton
              color="inherit"
              className={classes.actionButton}
              onClick={handleToggle}
              ref={anchorRef}
            >
              <MoreVertIcon size="small" />
            </IconButton>
          ) : (
            ""
          )}
          <Popper
            open={open}
            anchorEl={anchorRef.current}
            role={undefined}
            transition
            disablePortal
            style={{ zIndex: 1000 }}
          >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                style={{
                  transformOrigin:
                    placement === "bottom" ? "center top" : "center bottom",
                }}
              >
                <Paper>
                  <ClickAwayListener onClickAway={handleClose}>
                    <MenuList
                      id="menu-list-grow"
                      onKeyDown={handleListKeyDown}
                      className={classes.menuList}
                    >
                      {isVisibleAttribute(visibleAttributes, "Download") ? (
                        <MenuItem
                          className={classes.extraMenuItem}
                          onClick={(event) => {
                            amplitudeLogger.logEvent("CLICK_CHART_OPTIONS", {
                              attribute: "download",
                              page: amplitudePage,
                              metric_name: selectedMetric,
                            });
                            handleClose(event);
                            handleDownload(event);
                          }}
                        >
                          <ListItemIcon>
                            <GetAppIcon fontSize="small" />
                          </ListItemIcon>
                          <span className={classes.dropdownElements}>
                            Download
                          </span>
                        </MenuItem>
                      ) : (
                        ""
                      )}
                      {isVisibleAttribute(visibleAttributes, "Edit") ? (
                        <MenuItem
                          className={classes.extraMenuItem}
                          onClick={(event) => {
                            amplitudeLogger.logEvent("CLICK_CHART_OPTIONS", {
                              attribute: "edit",
                              page: amplitudePage,
                              metric_name: selectedMetric,
                            });
                            handleClose(event);
                            history.push(
                              `/analytics/metrics-explorer?chartSlug=${chartSlug}`
                            );
                          }}
                        >
                          <ListItemIcon>
                            <EditIcon fontSize="small" />
                          </ListItemIcon>
                          <span className={classes.dropdownElements}>Edit</span>
                        </MenuItem>
                      ) : (
                        ""
                      )}
                      {isVisibleAttribute(visibleAttributes, "Share") ? (
                        <MenuItem
                          className={classes.extraMenuItem}
                          onClick={(event) => {
                            amplitudeLogger.logEvent("CLICK_CHART_OPTIONS", {
                              attribute: "share",
                              page: amplitudePage,
                              metric_name: selectedMetric,
                            });
                            window.open(
                              `/analytics/charts?chartSlug=${chartSlug}`
                            );
                            handleClose(event);
                          }}
                        >
                          <ListItemIcon>
                            <ShareIcon fontSize="small" />
                          </ListItemIcon>
                          <span className={classes.dropdownElements}>
                            Share
                          </span>
                        </MenuItem>
                      ) : (
                        ""
                      )}

                      {isVisibleAttribute(visibleAttributes, "Delete") ? (
                        <>
                          <Divider />
                          <MenuItem
                            className={`${classes.extraMenuItem} ${classes.redText}`}
                            onClick={(event) => {
                              amplitudeLogger.logEvent("CLICK_CHART_OPTIONS", {
                                attribute: "delete",
                                page: amplitudePage,
                                metric_name: selectedMetric,
                              });
                              handleClose(event);
                              onDelete(event);
                            }}
                          >
                            <ListItemIcon className={classes.redText}>
                              <DeleteIcon fontSize="small" />
                            </ListItemIcon>
                            <span className={classes.dropdownElements}>
                              Delete
                            </span>
                          </MenuItem>
                        </>
                      ) : (
                        ""
                      )}
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </div>
      </div>
      <div className={classes.graphContainer}>
        {chartType === 1 ? (
          tableData.length === 0 ? (
            ""
          ) : (
            <TableContainer className={classes.tableContainer}>
              <Table size="small" className={classes.table}>
                <TableHead className={classes.bolder}>
                  <TableRow>
                    {tableData[0].map((cell, index) => (
                      <TableCell align={index === 0 ? "left" : "center"}>
                        {cell}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tableData.slice(1).map((row) => {
                    return (
                      <TableRow>
                        {row.map((cell, index) => (
                          <TableCell
                            className={index === 0 ? classes.bolder : ""}
                            align={index === 0 ? "left" : "center"}
                          >
                            {cell}
                          </TableCell>
                        ))}
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          )
        ) : (
          <ReczeeChart
            data={analyticsObject.getGraphOptions(backendData)}
            dataType={analyticsObject.dataType}
            onLoadCallback={onLoadCallback}
          />
        )}
      </div>
    </div>
  );
}

export default React.memo(AnalyticsChart);
